import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ValidationRule} from '../../models/validation-rule.model';
import {NgModel} from '@angular/forms';
import {GenericFunctionsUtil} from '../../utils/generic-functions.util';
import {ValidationService} from '../../services/validation.service';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'si-validation-element',
  templateUrl: './validation-element.component.html',
  styleUrls: ['./validation-element.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ValidationElementComponent {
  @Input() formModel: NgModel;
  @Input() showErrorText: boolean;
  @Output() errorTextChange = new EventEmitter<string>();
  errorText: string;
  externalErrorText: string;
  externalWarningText: string;
  showRequiredElementFlag = false;

  constructor(
    private validationService: ValidationService,
    private liveAnnouncer: LiveAnnouncer,
    private translateService: TranslateService) {
  }

  showRequiredElement(): void {
    setTimeout(() => {
      this.showRequiredElementFlag = true;
    });
  }

  hideRequiredElement(): void {
    this.showRequiredElementFlag = false;
  }

  showWarning(invalidKey: string, validationRule: ValidationRule): void {
    this.externalWarningText = null;
    if (
      !this.validationService.getShowRuleErrorForNotNull()
      && (invalidKey === 'notNull' || invalidKey === 'notNullCheck' || invalidKey === 'notNullCheckMultiple')
    ) {
      this.hideWarning();
      return;
    }

    this.setErrorText(GenericFunctionsUtil.stringReplaceArguments(validationRule.message, validationRule.arguments));
  }

  hideWarning(): void {
    this.setErrorText(null);
    this.externalErrorText = null;
    this.externalWarningText = null;
  }

  showExternalErrorText(text: string): void {
    this.hideWarning();
    this.externalErrorText = text;
    if (text) {
      this.liveAnnouncer.announce(this.translateService.instant(text), 'polite');
    }
  }

  showExternalWarningText(text: string): void {
    this.hideWarning();
    this.externalWarningText = text;
    if (text) {
      this.liveAnnouncer.announce(this.translateService.instant(text), 'polite');
    }
  }

  setErrorText(text: string): void {
    this.errorText = text;
    this.errorTextChange.emit(this.errorText);
    if (text) {
      this.liveAnnouncer.announce(this.translateService.instant(text), 'polite');
    }
  }
}
